
import { BaggingScanFailed } from "@/domain/entities/Bagging";
import { prop, Vue } from "vue-class-component";
import XLSX from "xlsx";

export class Props {
  data = prop<BaggingScanFailed[]>({
    default: () => [],
    required: true,
    type: Array
  });
}

class ScanFailedCard extends Vue.with(Props) {
  XLSX = XLSX;
  downloadExcel() {
    const data = this.XLSX.utils.json_to_sheet(
      this.data.map((d) => ({
        [this.$t("bagging.excel.noStt")]: d.sttNumber,
        [this.$t("bagging.excel.status")]: d.lastStatus,
        [this.$t("bagging.excel.reason")]: d.failureReason
      }))
    );
    const wb = this.XLSX.utils.book_new();
    this.XLSX.utils.book_append_sheet(wb, data, this.$t("bagging.excel.title"));
    this.XLSX.writeFile(wb, `${this.$t("bagging.excel.title")}.xlsx`);
  }
}
export default ScanFailedCard;
